import { Component, OnInit, ChangeDetectionStrategy, ViewChildren, TemplateRef, QueryList, Input, HostListener } from '@angular/core';
import { IModelContext } from '../../models/IModelContext';
import { MetadataTemplateManagerService } from '../../services/metadata-template-manager.service';
import { FormGroup } from '@angular/forms';
import { RuleVioliationManagerService } from '../../services/rule-violiation-manager.service';

@Component({
  selector: 'plr-metadata-form-control',
  templateUrl: './metadata-form-control.component.html',
  styleUrls: ['./metadata-form-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MetadataFormControlComponent implements OnInit {
  metadataTemplate: TemplateRef<any>;

  @Input()
  modelContext: IModelContext;

  @Input()
  formGroup: FormGroup;

  constructor(private metadataTemplateManager: MetadataTemplateManagerService,
              private ruleViolationManager: RuleVioliationManagerService) { }

  ngOnInit() {
    this.metadataTemplate = this.metadataTemplateManager.getTemplate(this.modelContext.metadata.templateType);
  }

  ngAfterViewInit() {
  }

  @HostListener('focusin')
  onFocus() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pillar/workspace/components/metadata-form-control/metadata-form-control.component.ts